module.exports = __webpack_public_path__ + "img/btn-prev.41a2f14f.svg";